export const MODIFY_ALL_DB_INFO = 'MODIFY_ALL_DB_INFO';

export function modifyAllDBInfo(allDBInfo){
    return{
        type: MODIFY_ALL_DB_INFO,
        mainState: {
            allDBInfo: allDBInfo
        }
    }
}